import { render } from "./NotesContent.vue?vue&type=template&id=c2eb9d24"
import script from "./NotesContent.vue?vue&type=script&lang=js"
export * from "./NotesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__